import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useIntl } from 'react-intl'
import { WorkPolicy } from 'views/work-policy'

const WorkPolicyPage: NextPage = () => {
  const { formatMessage } = useIntl()

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'workpolicy.meta.title' })}
        description={formatMessage({ id: 'workpolicy.meta.description' })}
      />
      <Header bordered={false} />
      <WorkPolicy />
      <Footer />
    </>
  )
}

export default WorkPolicyPage
